import { InputComponentEmits, useInputComponent } from "./useInputComponent.mjs";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useSlots } from "#imports";
export const TextInputComponentEmits = [...InputComponentEmits, "update:active", "change", "key-esc", "key-enter", "key-delete", "blur", "change", "focus"];
export function useTextInputComponent(inputElement, props, emit = () => {
}, options = {}) {
  const { submitValue, sizeableString, shouldValidate, validate, reset, isRequired, hasError, hasInput, isEmpty, errorMessage, clearValue } = useInputComponent(props, emit, options);
  const slots = useSlots();
  const isActive = ref(false);
  watch(() => props.active, (newValue) => {
    isActive.value = newValue;
  });
  watch(isActive, (newValue) => {
    if (newValue !== props.active) {
      emit("update:active", newValue);
    }
  });
  const hasPrefix = computed(() => {
    return !!props.icon;
  });
  const hasSuffix = computed(() => {
    return !!(props.help || props.clearable && submitValue.value || slots.suffix);
  });
  watch(submitValue, (newValue) => {
    if (isActive.value) {
      nextTick(() => {
        emit("change", newValue);
      });
    }
  });
  function handleKeydown(event) {
    switch (event.key) {
      case "Enter":
        handleEnter(event);
        break;
      case "Backspace":
      case "Delete":
        handleDelete(event);
        break;
      case "Escape":
        emit("key-esc", event);
        break;
    }
  }
  function handleEnter(event = null) {
    if (props.type === "search") {
      blur();
    }
    emit("key-enter", event);
  }
  function handleDelete(event = null) {
    options.onDeleteKey?.();
    emit("key-delete", event);
  }
  function handleBlur() {
    isActive.value = false;
    options.onBlur?.();
    emit("blur", submitValue.value);
  }
  function handleFocus() {
    if (!props.disabled) {
      isActive.value = true;
      emit("focus");
    }
  }
  function blur() {
    if (inputElement.value) {
      inputElement.value.blur();
    } else {
      handleBlur();
    }
  }
  function focus() {
    if (inputElement.value) {
      inputElement.value.focus();
    } else {
      handleFocus();
    }
  }
  function tryAutoFocus() {
    if (!props.autofocus || typeof document === "undefined" || !inputElement.value || document.activeElement === inputElement.value) {
      return false;
    }
    focus();
    return true;
  }
  onMounted(() => {
    nextTick(() => {
      if (props.autofocus && inputElement.value) {
        tryAutoFocus();
      }
    });
  });
  return {
    submitValue,
    focus,
    handleFocus,
    blur,
    handleBlur,
    handleEnter,
    tryAutoFocus,
    isActive,
    isRequired,
    hasSuffix,
    hasPrefix,
    hasError,
    hasInput,
    shouldValidate,
    validate,
    errorMessage,
    sizeableString,
    isEmpty,
    handleKeydown,
    clearValue,
    reset
  };
}
